// Shared Google Translate helpers used by the nav selector + the first-visit prompt.
export const LANGS = [
  { code: "en", label: "English" },
  { code: "es", label: "Español" },
  { code: "id", label: "Bahasa Indonesia" },
  { code: "zh-TW", label: "繁體中文" },
];

export function readLangCookie() {
  const m = document.cookie.match(/googtrans=\/[^/]*\/([^;]+)/);
  return m ? decodeURIComponent(m[1]) : "en";
}

export function applyLanguage(code) {
  const host = window.location.hostname;
  // Returning to English: Google won't "un-translate" via the dropdown, so
  // clear the googtrans cookie (all path/domain variants) and reload.
  if (!code || code === "en") {
    const expire = "expires=Thu, 01 Jan 1970 00:00:00 GMT";
    document.cookie = `googtrans=;${expire};path=/`;
    document.cookie = `googtrans=;${expire};path=/;domain=${host}`;
    document.cookie = `googtrans=;${expire};path=/;domain=.${host}`;
    window.location.reload();
    return;
  }
  const val = `/en/${code}`;
  document.cookie = `googtrans=${val};path=/`;
  document.cookie = `googtrans=${val};path=/;domain=.${host}`;
  const combo = document.querySelector(".goog-te-combo");
  if (combo) {
    combo.value = code;
    combo.dispatchEvent(new Event("change"));
  } else {
    window.location.reload();
  }
}

// Maps the visitor's browser language to a supported non-English code, or null.
// A `?_hl=<code>` query param can override the detected browser language
// (useful for shareable localized links and testing).
export function detectSupportedLang() {
  const norm = (raw) => {
    const l = (raw || "").toLowerCase();
    if (l.startsWith("es")) return "es";
    if (l.startsWith("id") || l.startsWith("in")) return "id"; // 'in' = legacy Indonesian code
    if (l.startsWith("zh") && (l.includes("tw") || l.includes("hk") || l.includes("hant") || l.includes("mo"))) return "zh-TW";
    return null;
  };
  try {
    const hint = new URLSearchParams(window.location.search).get("_hl");
    if (hint) return norm(hint);
  } catch { /* ignore */ }
  const langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || ""]);
  for (const raw of langs) {
    const code = norm(raw);
    if (code) return code;
  }
  return null;
}

// Localized "view in your language?" prompt copy.
export const LANG_PROMPT = {
  es: { msg: "¿Ver este sitio en Español?", action: "Sí" },
  id: { msg: "Lihat situs ini dalam Bahasa Indonesia?", action: "Ya" },
  "zh-TW": { msg: "以繁體中文瀏覽本網站？", action: "好" },
};
